module.exports = __webpack_public_path__ + "img/rencaizhaopin-bg.b1965d07.png";